// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TemplateRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TemplateRow — one row of `franchisor_channel_templates`.
 * `subject` is null for every sms row (email-only field, DDL-level).
 *
 * `language` is a BCP-47 tag (TemplateLanguages::supported()). The row key is
 * the TRIPLE (trigger_key, channel_type, language) — only pt-BR is seeded;
 * the other variants exist once staff creates them.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_TemplateRow {
id: number
channel_type?: string
trigger_key?: string
language?: string
subject?: string
body?: string
updated_by?: string
created_at?: string
updated_at?: string
}

registerContract('FranchisorChannels_TemplateRow', {
  id:           { type: 'number',  required: true },
  channel_type: { type: 'string',  required: false },
  trigger_key:  { type: 'string',  required: false },
  language:     { type: 'string',  required: false },
  subject:      { type: 'string',  required: false },
  body:         { type: 'string',  required: false },
  updated_by:   { type: 'string',  required: false },
  created_at:   { type: 'string',  required: false },
  updated_at:   { type: 'string',  required: false },
})
